import React, { useEffect, useState } from 'react';
import { parentApi } from '../../services/api';

interface Child {
  id: number | string;
  name?: string;
  first_name?: string;
  last_name?: string;
  student_profiles?: { student_code?: string };
  class_student_enrollments?: Array<{
    classes?: { name?: string; campuses?: { institutions?: { name?: string } } };
  }>;
}

const ParentStudentSelection: React.FC = () => {
  const [children, setChildren] = useState<Child[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    parentApi.children()
      .then((res) => setChildren(res.data || []))
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  return (
    <div>
      <h1 className="text-[20px] lg:text-[24px] font-semibold text-[#2b2b2b] mb-2">Öğrenci Seçimi</h1>
      <p className="text-[14px] lg:text-[16px] text-gray-500 mb-6 lg:mb-8">
        Görüntülemek istediğiniz öğrenciyi seçiniz.
      </p>

      {loading ? (
        <div className="flex justify-center py-16"><div className="w-8 h-8 border-4 border-[#3973bf] border-t-transparent rounded-full animate-spin" /></div>
      ) : children.length === 0 ? (
        <p className="text-center text-gray-400 py-16">Henüz bağlı çocuğunuz yok. Veli bağları eis ekosistem üzerinden yönetilir; çocuğunuz görünmüyorsa okulunuzla iletişime geçin.</p>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-5">
          {children.map((c) => {
            const name = c.name ?? `${c.first_name ?? ''} ${c.last_name ?? ''}`.trim();
            const enrollment = c.class_student_enrollments?.[0];
            const className = enrollment?.classes?.name ?? '-';
            const institution = enrollment?.classes?.campuses?.institutions?.name ?? '';
            return (
              <div
                key={c.id}
                className="bg-[#fafafa] rounded-[24px] p-5 lg:p-6 cursor-pointer hover:shadow-md hover:border-[#3973bf] border-2 border-transparent transition-all"
              >
                <div className="flex flex-col items-center">
                  <img src="/a-avatar.png" alt="" className="w-[80px] h-[80px] lg:w-[100px] lg:h-[100px] rounded-full object-cover mb-3 lg:mb-4" />
                  <p className="text-[16px] lg:text-[20px] font-semibold text-[#2b2b2b] text-center">{name || '-'}</p>
                  {institution && <p className="text-[13px] lg:text-[14px] text-gray-500 mt-1">{institution}</p>}
                  <p className="text-[13px] lg:text-[14px] text-[#3973bf] font-medium mt-1">{className}</p>
                  {c.student_profiles?.student_code && (
                    <p className="text-[11px] text-gray-400 mt-1">{c.student_profiles.student_code}</p>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default ParentStudentSelection;
